/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Frame_Rate_LabelInputs */



/**
* | output |
* | --- |
* | "Frame Rate" |
*
* @param {New_Project_Frame_Rate_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_frame_rate_label = /** @type {((inputs?: New_Project_Frame_Rate_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Frame_Rate_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cadence")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildrate")
	if (locale === "it") return /** @type {LocalizedString} */ ("Frequenza dei fotogrammi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Частота кадров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad de fotogramas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧率")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレームレート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ्रेम रेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Taxa de quadros")
	return /** @type {LocalizedString} */ ("Frame Rate")
});